import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FrameworkUtilityComponent } from '../../form-utlity/framework-utility';
import { I18nService } from 'src/app/service/i18n.service';
import { UtilService } from 'src/app/service/util.service';
import * as CONSTANTS from '../../constants';
import { WebStorageService, Scope } from '@mmortgage/common-utility';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'audit-header',
  templateUrl: './auditHeader.component.html',
  styleUrls: ['./auditHeader.component.less'],
  providers: [FrameworkUtilityComponent]
})
export class AuditHeaderComponent implements OnInit {
  currentRoutePath: any;
  heading: any;
  constructor(private router: Router, private util: UtilService, private activatedRoute: ActivatedRoute) {
  }
  ngOnInit(): void {
    this.activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });


    if (localStorage.getItem('viewType') == "Request") {
      this.heading = "Request";
    }
    if (localStorage.getItem('viewType') == "Response") {
      this.heading = "Response";
    }
    if (this.currentRoutePath == "integration-audit") {
      this.heading = "Integration Audit Tracker";
    }

  }
}